import React from "react";

const FoundHerFooter = () => {
  return (
    <footer className="bg-gradient-to-b from-[#220b20] via-[#180916] to-black border-t border-pink-400/10 py-8 px-6">
      <div className="max-w-6xl mx-auto grid lg:grid-cols-12 gap-8">
        <div className="lg:col-span-5">
          <div className="flex items-center justify-center gap-3 mb-4">
            <span className="text-xl lg:2xl">💜</span>
            <h2 className="text-lg lg:text-xl font-black tracking-tight text-white">
              FoundHer
            </h2>
          </div>

          <p className="text-rose-200 text-xs lg:text-sm leading-relaxed max-w-md">
            A PurpleDoor initiative by Think5Whys empowering the next
            generation of women entrepreneurs through purpose, learning,
            mentorship, community, and opportunity.
          </p>

          <div className="mt-4 text-xs lg:text-sm text-rose-300">
            © 2026 Think5Whys. All rights reserved.
          </div>
        </div>

        <div className="lg:col-span-3">
          <div className="uppercase tracking-[0.25em] text-sm lg:text-lg text-pink-300 mb-4">
            Ecosystem
          </div>
          <div className="space-y-2 text-rose-200 text-xs lg:text-sm">
            <div>👩 Women Founders</div>
            <div>🛍 Marketplace</div>
            <div>🎓 Learning & Academy</div>
            <div>🤝 Mentorship</div>
            <div>💰 Funding & Support</div>
            <div>🌐 Community Network</div>
          </div>
        </div>

        <div className="lg:col-span-4 flex flex-col justify-between">
          <div>
            <div className="uppercase tracking-[0.25em] text-xs text-pink-300 mb-4">
              Our Vision
            </div>
            <h3 className="text-lg lg:text-xl font-bold text-white leading-snug mb-4">
              Every young woman deserves<br />the opportunity to become a founder.
            </h3>
            <p className="text-rose-200 text-xs lg:text-sm leading-relaxed">
              We believe entrepreneurship grows stronger when communities
              choose to buy, mentor, encourage, and celebrate women who dare
              to build something meaningful.
            </p>
          </div>

          <div className="mt-4 text-pink-300 text-sm lg:text-lg font-semibold">
            Find Her • Fund Her • Found Her 💜
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FoundHerFooter;